import * as React from "react";

interface IFearCityDialogProps {
  isShowingDialog: boolean;
  isHidingDialog: boolean;
  dialogX: number;
  dialogY: number;
}

class FearCityDialog extends React.Component<IFearCityDialogProps> {
  constructor(props: IFearCityDialogProps) {
    super(props);
  }

  public render() {
    return (
      <svg
        className={`city-dialog fear-city-dialog 
          ${this.props.isShowingDialog ? "isShowing" : ""}
          ${this.props.isHidingDialog ? "isHiding" : ""}
        `}
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 140.7 106.1"
        style={{ top: this.props.dialogY, left: this.props.dialogX }}
      >
        <a>
          <path
            fill="#E7E3E3"
            d="M69.9,0.4C31.6,0.4,0.5,24,0.5,53c0,13.1,6.3,25,16.7,34.3c0.4,0.4,0.5,1,0.2,1.5l-10,13.5
	c-0.7,0.9,0.3,2.2,1.4,1.7l19.1-8.5c0.3-0.1,0.7-0.1,1,0c11.5,6.4,25.7,10.2,41.1,10.2c38.3,0,69.4-23.6,69.4-52.7
	S108.2,0.4,69.9,0.4z"
          />
          <g>
            <path
              fill="#5D87C0"
              d="M28.3,60.1c0.6-0.7,1-1.9,1.2-3l1.4,0.4c-0.2,1.2-0.5,2.5-1.2,3.3L28.3,60.1z M28.6,54.9c0.9,0,1.9-0.1,3-0.1
		V54H29v-1.5h2.6v-0.8H29v-6.5h7.2v6.5h-2.8v0.8h2.7V54h-2.7v0.8c1,0,2-0.1,3-0.1v1.6c-2.8,0.2-5.7,0.3-7.8,0.4L28.6,54.9z
		 M30.5,50.4H32v-3.7h-1.4v0.7l0.8-0.2c0.3,0.8,0.5,1.8,0.5,2.5L31,49.9c0-0.7-0.2-1.6-0.4-2.4v2.9H30.5z M32.2,57
		c0.2,1,0.3,2.2,0.4,3l-1.3,0.2c0-0.8-0.1-2-0.3-3L32.2,57z M33.8,56.8c0.3,0.9,0.6,2.1,0.7,2.8l-1.2,0.3c-0.1-0.8-0.4-2-0.7-2.9
		L33.8,56.8z M34.7,46.7h-1.5v2.8c0.2-0.7,0.5-1.7,0.7-2.4l0.8,0.3V46.7z M34.7,50.4V48c-0.3,0.7-0.5,1.5-0.8,2l-0.7-0.3v0.7H34.7z
		 M35.5,56.5c0.5,0.8,1.1,1.9,1.3,2.7l-1.3,0.5c-0.2-0.8-0.7-1.9-1.2-2.7L35.5,56.5z M41.1,50.2v2.6h2.7v7.9h-2v-0.6h-3.2v0.7h-1.8
		v-7.9H39v-8h2v3.5h3.3v1.9h-3.2V50.2z M41.9,54.7h-3.2v3.6h3.2V54.7z"
            />
            <path
              fill="#5D87C0"
              d="M60.7,52.9c-0.8,1.4-1.7,2.6-2.8,3.7c0.5,1.3,1,2.1,1.5,2.1c0.4,0,0.6-0.8,0.7-2.8c0.4,0.5,1.1,0.9,1.7,1.2
		c-0.3,3-1,3.7-2.5,3.7c-1.2,0-2.2-1-2.9-2.7c-1,0.8-2.1,1.5-3.2,2.1c-0.3-0.5-0.9-1.2-1.4-1.6c1.3-0.6,2.6-1.4,3.8-2.4
		c-0.4-1.4-0.7-2.9-0.9-4.6h-3.5v2c0.9-0.2,1.8-0.3,2.6-0.5l0.2,1.8l-2.8,0.6v2.9c0,1.1-0.2,1.7-0.9,2s-1.7,0.4-3.1,0.4
		c-0.1-0.6-0.4-1.5-0.7-2.1c1,0.1,2,0,2.3,0s0.4-0.1,0.4-0.4v-2.5c-1.1,0.2-2.2,0.4-3.1,0.6l-0.5-2.1c1-0.2,2.2-0.3,3.6-0.6v-2.3H46
		v-1.9h3.2v-2c-0.9,0.2-1.9,0.3-2.7,0.4c-0.1-0.5-0.4-1.2-0.6-1.7c2.4-0.3,5.1-0.9,6.8-1.4l1.4,1.7c-0.9,0.3-1.8,0.5-2.8,0.7v2.3
		h3.3c-0.1-1.5-0.2-3.1-0.2-4.7h2.1c0,1.6,0,3.2,0.2,4.7h4.7v1.9h-4.5c0.1,1,0.3,2,0.5,2.9c0.6-0.7,1.2-1.5,1.6-2.3L60.7,52.9z
		 M59.4,49.1c-0.4-0.8-1.5-2-2.4-2.8l1.5-1c0.9,0.8,2,1.9,2.5,2.7L59.4,49.1z"
            />
            <path
              fill="#5D87C0"
              d="M69,51.6c-0.1,0.2-0.3,0.5-0.4,0.7h8v8.5h-2.1v-0.6h-6.2v0.6h-2v-5.6c-0.8,0.8-1.6,1.5-2.6,2.1
		c-0.3-0.5-0.9-1.2-1.3-1.6c1.8-1,3.1-2.4,4.2-4H63V50h4.5c0.1-0.2,0.2-0.5,0.3-0.7h-3.6v-1.5h4.2c0.1-0.2,0.1-0.5,0.2-0.7
		c-1.4,0.1-2.8,0.1-4.2,0.1c0-0.4-0.2-1.1-0.4-1.5c4.2,0,9.1-0.2,12-0.7l1.2,1.5c-1.8,0.3-4.1,0.5-6.4,0.6c-0.1,0.3-0.2,0.5-0.2,0.8
		h6.7v1.5H70c-0.1,0.2-0.2,0.5-0.3,0.7h8.5v1.6L69,51.6L69,51.6z M74.6,53.9h-6.2v0.7h6.2V53.9z M74.6,55.9h-6.2v0.8h6.2V55.9z
		 M74.6,58.7v-0.8h-6.2v0.8H74.6z"
            />
            <path
              fill="#5D87C0"
              d="M94.7,49.7c-0.4,2.6-1.1,4.8-2.1,6.5c0.9,1.2,2,2.1,3.4,2.8c-0.5,0.4-1.1,1.2-1.4,1.8
		c-1.4-0.7-2.5-1.6-3.3-2.8c-1,1.1-2.3,2-3.9,2.7c-0.2-0.5-0.7-1.3-1.1-1.7h-4v1h-1.9v-7.6h2.3v-2.6h-3v-1.9h3v-3.1h2v3.1h2.8v1.9
		h-2.8v2.6h1.9c-0.2-0.1-0.3-0.3-0.5-0.3c1.5-1.7,2.5-4.4,2.9-7.3l2.1,0.3c-0.2,0.9-0.4,1.8-0.7,2.7h5.2v1.9
		C95.6,49.7,94.7,49.7,94.7,49.7z M85.1,54.3h-2.7v2.8h2.7V54.3z M87.1,58.6c1.3-0.6,2.3-1.4,3.1-2.3c-0.6-1.1-1.1-2.4-1.5-3.9
		c-0.2,0.4-0.5,0.8-0.8,1.1c-0.2-0.2-0.5-0.5-0.9-0.7v5.8H87.1z M90,49.7c0.3,1.7,0.8,3.2,1.4,4.6c0.6-1.3,1-2.8,1.3-4.6H90z"
            />
            <path
              fill="#5D87C0"
              d="M112.8,56H111v3h-2v-0.7h-3.1v0.5c0,1-0.2,1.4-0.9,1.7c-0.7,0.3-1.6,0.3-3,0.3c-0.1-0.5-0.4-1.2-0.7-1.6
		c0.8,0,1.8,0,2.1,0c0.3,0,0.4-0.1,0.4-0.4v-0.5h-5.2v-1.5h5.2V56H97v-1.6h6.8v-0.7h-5.1v-1.4h5.1v-0.8h-4.6v-3.4h4.6v-0.7h-6.4
		v-1.6h6.4v-1.1h2.1v1.1h6.5v1.6h-6.5v0.7h4.9v3.4h-4.9v0.8h5.2v2.1h1.8L112.8,56L112.8,56z M103.8,50.3v-0.8h-2.7v0.8H103.8z
		 M105.9,49.5v0.8h2.8v-0.8H105.9z M105.9,54.5h3.1v-0.7h-3.1V54.5z M109,56h-3.1v0.8h3.1V56z"
            />
          </g>
        </a>
      </svg>
    );
  }
}

export default FearCityDialog;



// WEBPACK FOOTER //
// ./src/home/components/FearCityDialog.tsx